import React from 'react'

function Header() {
  return (
    <div id='main'>
    <div id='name'>
        <div className='header-headings'>
            <h2>STEP UP YOUR</h2>
            <h1><span>FITNESS</span> WITH US</h1>
            <p className="details">Build Your Body And Fitness With Professionals Touch</p>

            {/* <div className="header-btn">JOIN US</div> */}
        </div>
        
      </div>
    </div>
  )
}

export default Header
